import { render, staticRenderFns } from "./review-vital.vue?vue&type=template&id=364da802&scoped=true&"
import script from "./review-vital.vue?vue&type=script&lang=js&"
export * from "./review-vital.vue?vue&type=script&lang=js&"
import style0 from "./review-vital.vue?vue&type=style&index=0&id=364da802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364da802",
  null
  
)

export default component.exports